import React from 'react';
import { motion } from 'framer-motion';
export function Philosophy() {
  return <section className="py-32 md:py-48 bg-white relative overflow-hidden" data-id="element-293">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-secondary/30 -skew-x-12 translate-x-20" data-id="element-294"></div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 relative z-10" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="text-center" data-id="element-296">
          <span className="text-primary font-medium tracking-widest uppercase text-sm mb-8 block" data-id="element-297">
            Philosophie
          </span>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-serif text-accent mb-12 leading-tight" data-id="element-298">
            Bestehendes weiterdenken
          </h2>

          <div className="text-xl md:text-2xl text-accent/80 font-light leading-relaxed max-w-4xl mx-auto text-balance" data-id="element-299">
            <p data-id="element-300">
              Jedes Bestandsgebäude trägt eine eigene Geschichte – in seiner
              Substanz, seinen Materialien und seiner Nutzung über die Jahre.
              Häufig liegt der nachhaltigere Weg darin, diese Substanz mit
              Sorgfalt weiterzuentwickeln, statt sie zu ersetzen. Nachhaltigkeit
              bedeutet für mich mehr als reine Energieeinsparung: Es geht um
              einen verantwortungsvollen Umgang mit Ressourcen, Materialien und
              gewachsenen Strukturen – und um Räume, in denen Menschen
              langfristig gut leben können.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}